import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

var show = (confirm) => {
    const MySwal = withReactContent(Swal)
    MySwal.fire({
        allowOutsideClick: true,
        title: 'کلمه عبور خود را تغییر می دهید؟',
        icon: 'warning',
        html:
            '<div class="col-12  p-0 m-0" >' +
            '<input id="old-password" type="password" class="form-control p-3 mb-2" placeholder="کلمه عبور قدیم">' +
            '<input id="new-pasword" type="password" class="form-control p-3 mb-2"  placeholder="کلمه عبور جدید">' +
            '<input id="new-password-check" type="password" class="form-control p-3 mb-2"  placeholder="تکرار کلمه عبور جدید">' +
            '</div>',
        confirmButtonText: "ثبت شود",
        denyButtonText: "انصراف",
        showDenyButton: true,
        preConfirm: () => {
            confirm({
                oldPass: document.getElementById('old-password').value,
                newPass: document.getElementById('new-pasword').value,
                newPassCheck: document.getElementById('new-password-check').value
            })

        }

    })
    return MySwal;
}

export default {
    show: show,
}

